// extracted by css-extract-rspack-plugin
export default {"PopoverTrigger":"ValuesYouCanReference-module__PopoverTrigger___fk4tF"};